import { AccessBadge } from "~/pages/manifold-nextgen/components/AccessBadge";
import { ProjectAccessLevel } from "~/services/projects";

export const ACCESS_LEVEL_LABEL: Record<ProjectAccessLevel, string> = {
  [ProjectAccessLevel.OWNER]: "Owner",
  [ProjectAccessLevel.USER]: "User",
};

interface ProjectAccessBadgeProps {
  accessLevel: ProjectAccessLevel | null;
  /** Suppress the chip for the default USER access level. */
  hideDefault?: boolean;
}

export function ProjectAccessBadge({ accessLevel, hideDefault }: ProjectAccessBadgeProps) {
  const isHidden = hideDefault && accessLevel === ProjectAccessLevel.USER;
  return <AccessBadge label={!isHidden && accessLevel ? ACCESS_LEVEL_LABEL[accessLevel] : null} />;
}
